define('controller/people/external.associations.detail.controller',['require','exports','module','fukit/fukit','model/external.association.model','view/people/external.associations.page.view','fukit/fukit','model/organization.model','model/person.model','fukit/fukit','fukit/fukit','any.roles','underscore','backbone.radio'],function(require, exports, module) {
  // prettier-ignore
  var BaseController                 = require('fukit/fukit').BaseController,
      ExternalAssociationsModel      = require('model/external.association.model'),
      ExternalAssociationsDetailView = require('view/people/external.associations.page.view'),
      RouteHelper                    = require('fukit/fukit').RouteHelper,
      OrganizationModel              = require('model/organization.model'),
      PersonModel                    = require('model/person.model'),
      RolesHelper                    = require('fukit/fukit').RolesHelper,
      CollectionUtil                 = require('fukit/fukit').CollectionUtil,
      ANYROLES                       = require('any.roles'),
      has                            = require('underscore').has,
      Radio                          = require('backbone.radio');

  var ExternalAssociationsDetailController = BaseController.extend({
    radioRequests: {
      'controllers ExternalAssociationsDetailController': '@constructor',
    },

    pageView: ExternalAssociationsDetailView,

    resources: {
      person: {
        model: PersonModel,
      },
      currentPersonCollection: {
        collection: PersonModel.Collection,
      },
      externalAssociations: {
        fetchOnStart: true,
        model: ExternalAssociationsModel,
        attrs: {
          id: '@state.id',
        },
      },
      organizations: {
        collection: OrganizationModel.Collection,
      },
    },

    onStart: function() {
      var userPrincipalModel = Radio.request('AppKit.resourceService', 'resource', 'userPrincipalModel');
      if (has(userPrincipalModel, 'id')) {
        var personModel = this.getResource('person');
        var currentPersonCollection = this.getResource('currentPersonCollection');
        currentPersonCollection.filters.addFilterWithField({ name: 'userAccountId' }).equals(userPrincipalModel.id);
        currentPersonCollection
          .fetch()
          .promise()
          .then(function() {
            if (currentPersonCollection.models.length === 0) {
              return;
            }

            personModel.set(currentPersonCollection.models[0].toJSON());
          });
      }

      if (RolesHelper.evaluateRoleArrayAgainstUserRoles(ANYROLES.ANY_EXTERNAL_ORG_ROLE)) {
        var organizationsCollection = this.getResource('organizations');
        organizationsCollection.paginate.set('size', 2000);
        organizationsCollection.sort.field('name').makeAscending();
        organizationsCollection.fetch();
      }
    },
  });

  module.exports = ExternalAssociationsDetailController;
});

